<template>
    <el-row class="main-box flex-cloumn flex1">
        <el-col>
            <el-row>
                <el-col>
                    <div class="head-box flex-column">
                        <el-image class="head-box-bg" src="https://language-training.oss-cn-hangzhou.aliyuncs.com/frontImage/image2.jpg" fit="cover"
                            :lazy="true"></el-image>
                        <div class="head-box-text1">词汇量测试</div>
                        <div class="head-box-text2">知识源于积累</div>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col class="content-box-col" :sm="{ span: 22, offset: 0 }" :md="{ span: 22, offset: 1 }"
                    :lg="{ span: 22, offset: 1 }">

                    <template v-if="userInfos.role == 0">
                        <div class="content-box flex-cloumn ">
                            <span class="content-box-title">花几分钟测试一下，定位你的词汇量水平</span>
                            <div class="content-box-bottom">
                                <el-image class="content-box-bottom-bg"
                                    :src="require('@/static/vocabulary-text-contetn-bg.png')" fit="fill"
                                    :lazy="true"></el-image>
                                <div class="content-box-main flex-row f-align-center f-justify-between">
                                    <div class="flex-row f-align-center">
                                        <img src="../static/book_badge.png" alt="">
                                        <div class="content-box-main-info">
                                            <div>词汇量测试</div>
                                            <div>Vocabulary</div>
                                        </div>
                                    </div>
                                    <div @click="startHandle" class="content-box-main-btn">开始</div>

                                </div>
                                <el-image class="content-box-bottom-badge"
                                    src="https://language-training.oss-cn-hangzhou.aliyuncs.com/frontImage/image5.jpg" fit="cover"
                                    :lazy="true"></el-image>

                            </div>
                        </div>
                    </template>

                    <template v-else>

                        <div class="content-box flex-cloumn ">
                            <span class="content-box-title">花几分钟测试一下，定位你的词汇量水平</span>
                            <div class="content-box-bottom">
                                <el-image class="content-box-bottom-bg"
                                    :src="require('@/static/vocabulary-text-contetn-bg.png')" fit="fill"
                                    :lazy="true"></el-image>
                                <div class="content-box-main flex-row f-align-center f-justify-between">
                                    <div class="flex-row f-align-center">
                                        <img src="../static/book_badge.png" alt="">
                                        <div class="content-box-main-info">
                                            <div>词汇量测试</div>
                                            <div>Vocabulary</div>
                                        </div>
                                    </div>
                                    <div @click="startHandle" class="content-box-main-btn">开始</div>

                                </div>
                                <el-image class="content-box-bottom-badge"
                                   src="https://language-training.oss-cn-hangzhou.aliyuncs.com/frontImage/image5.jpg" fit="cover"
                                    :lazy="true"></el-image>

                            </div>
                        </div>


                    </template>



                </el-col>
            </el-row>

        </el-col>

        <el-dialog title="" :center="true" :visible.sync="dialogStartClass" :show-close="false">

            <el-row slot="title" style="width: 100%;">
                <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 24, offset: 0 }">
                    <div class="appraise-popup-title flex-row f-justify-between f-align-center">
                        <div style="width:56px;height:56px;"></div>
                        <span class="appraise-popup-title-name">提示</span>
                        <img @click="dialogStartClass = false" src="../static/close.png" alt="">
                    </div>

                </el-col>
            </el-row>
            <el-row style="width: 100%;">
                <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 24, offset: 0 }">
                    <div class="start-popup-content flex-column ">
                        <span class="start-popup-content-text1">结束课程并创建抗遗忘计划</span>
                        <div class="start-popup-content-timebox flex-row f-align-center">
                            <span>复习时间</span>
                            <div></div>
                        </div>
                        <div class="start-popup-content-line"></div>
                        <div class="start-popup-content-btnsbox flex-row f-justify-end">
                            <div>返回</div>
                            <div>提交</div>
                        </div>
                    </div>

                </el-col>
            </el-row>

        </el-dialog>

        <el-dialog title="" :center="true" :visible.sync="dialogConfrimStartClass" :show-close="false">

            <el-row slot="title" style="width: 100%;">
                <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 24, offset: 0 }">
                    <div class="appraise-popup-title flex-row f-justify-between f-align-center">
                        <div style="width:56px;height:56px;"></div>
                        <span class="appraise-popup-title-name">提示</span>
                        <img @click="dialogConfrimStartClass = false" src="../static/close.png" alt="">
                    </div>

                </el-col>
            </el-row>
            <el-row style="width: 100%;">
                <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 24, offset: 0 }">
                    <div class="start-popup-content flex-column f-align-center">
                        <div class="start-popup-content-tipsbox flex-row f-align-center">
                            <span>确认开始学员 <span style="color:#0AA26B;"> 谢志鹏</span> 的课程吗</span>
                        </div>
                        <div class="start-popup-content-line"></div>
                        <div class="start-popup-content-btnsbox flex-row f-justify-end" style="width:100%;">
                            <div>返回</div>
                            <div @click="startSubmit">提交</div>
                        </div>
                    </div>

                </el-col>
            </el-row>

        </el-dialog>

    </el-row>
</template>

<script>

import { mapState } from 'vuex';
export default {
    data() {
        return {
            dialogStartClass: false,
            dialogConfrimStartClass: false,
        }
    },
    computed: {
        ...mapState([
            'userInfos'
        ]),
    },
    methods: {
        startHandle() {
            this.$router.push({
                path: "/vocabulary_testlist"
            })
        },
        toWordRecognise() {
            this.$router.push({
                path: "/word_recognise"
            })
        },
        toWordTest() {
            this.$router.push({
                path: "/vocabulary_testlist"
            })
        },
        startSubmit() {
            this.$router.push({
                path: "/vocabulary_testlist"
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.main-box {
    background: #E5F3F1;

    position: relative;

    .head-box {
        width: 100%;
        height: 220px;
        position: relative;

        .head-box-bg {
            position: absolute;
            width: 100%;
            height: 470px;
            top: -80px;
        }

        .head-box-text1 {
            margin-top: 39px;
            margin-left: 212px;
            font-family: HelloFont WenYiHei;
            font-size: 50px;
            font-weight: normal;
            line-height: normal;
            letter-spacing: 0em;

            color: #FFFFFF;
            position: relative;
            z-index: 30;
        }

        .head-box-text2 {
            margin-top: 3px;
            margin-left: 212px;
            font-family: 思源黑体;
            font-size: 20px;
            font-weight: normal;
            line-height: normal;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            color: #FFFFFF;
            position: relative;
            z-index: 30;

        }

    }

    .content-box-col {
        display: flex;
        flex-direction: row;
        justify-content: center;
    }

    .content-box {
        width: 91.4777%;
        height: 466px;

        border-radius: 20px;
        opacity: 1;
        background: #FFFFFF;
        position: relative;
        z-index: 20;
        transform: translateY(-15px);


        .content-box-titlebox {
            margin-left: 55px;
            align-items: flex-end;
            position: relative;
            z-index: 20;
        }


        .content-box-title {
            display: inline-block;
            margin-top: 28px;
            margin-left: 55px;
            font-family: Source Han Sans CN;
            font-size: 35px;
            font-weight: bold;
            line-height: normal;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 333333 */
            color: #333333;
            position: relative;
            z-index: 30;
        }

        .content-box-title2 {
            margin-left: 29px;
            font-family: Source Han Sans CN;
            font-size: 30px;
            font-weight: normal;
            line-height: normal;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 333333 */
            color: #333333;
        }

        .content-box-bottom {
            margin-top: 21px;
            margin-left: 40px;
            width: 95.093%;
            height: 330px;
            position: relative;
            border-top: 1px solid transparent;
            box-sizing: border-box;

            .content-box-bottom-bg {
                width: 100%;
                height: 330px;
                position: absolute;
                top: 0;
                left: 0;
            }

            .content-box-bottom-badge {
                width: 470px;
                height: 423px;
                position: absolute;
                top: -82px;
                right: 87px;
            }


            .content-box-main {
                margin-top: 72px;
                margin-left: 65px;
                width: 470px;
                height: 207px;
                border-radius: 20px;
                opacity: 1;

                /* 纯白 */
                background: #FFFFFF;

                box-shadow: 0px 0px 10px 0px rgba(140, 199, 162, 0.2);
                position: relative;
                z-index: 30;

                img {
                    width: 100px;
                    height: 100px;
                    margin-left: 14px;
                    margin-right: 14px;
                }

                .content-box-main-info {
                    div {
                        &:first-child {
                            font-family: Source Han Sans CN;
                            font-size: 24px;
                            font-weight: bold;
                            line-height: normal;
                            letter-spacing: 0em;

                            font-feature-settings: "kern" on;
                            /* 333333 */
                            color: #333333;
                        }

                        &:last-child {
                            margin-top: 12px;

                            font-family: Oswald;
                            font-size: 24px;
                            font-weight: normal;
                            line-height: normal;
                            letter-spacing: 0em;

                            font-feature-settings: "kern" on;
                            /* 灰 */
                            color: #ACBEB0;
                        }

                    }
                }

                .content-box-main-btn {
                    margin-right: 30px;
                    text-align: center;
                    width: 134px;
                    height: 46px;
                    border-radius: 100px;
                    opacity: 1;

                    /* 绿 */
                    background: #0AA26B;
                    font-family: Source Han Sans CN;
                    font-size: 18px;
                    font-weight: bold;
                    line-height: 46px;
                    letter-spacing: 0em;

                    font-feature-settings: "kern" on;
                    /* 纯白 */
                    color: #FFFFFF;
                }

            }

        }

    }

    .content-box2 {
        width: 91.4777%;
        height: 610px;

        border-radius: 20px;
        opacity: 1;
        background: #FFFFFF;
        position: relative;
        z-index: 20;
        transform: translateY(-15px);

        .content-box2-tips {
            margin-top: 21px;
            margin-left: 23px;

            img {
                margin-right: 8px;
                width: 24px;
                height: 24px;
            }

            span {
                font-family: Source Han Sans CN;
                font-size: 18px;
                font-weight: bold;
                line-height: normal;
                letter-spacing: 0em;

                font-feature-settings: "kern" on;
                /* 333333 */
                color: #333333;
            }

        }

        .content-box-titlebox {
            margin-top: 38px;
            margin-left: 55px;
            align-items: flex-end;
        }

        .content-box-title {
            display: inline-block;
            font-family: Source Han Sans CN;
            font-size: 40px;
            font-weight: bold;
            line-height: normal;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 333333 */
            color: #333333;
            position: relative;
            z-index: 30;
        }

        .content-box-title2 {
            margin-left: 29px;
            font-family: Source Han Sans CN;
            font-size: 30px;
            font-weight: normal;
            line-height: normal;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 333333 */
            color: #333333;
        }

        .content-box-bottom {
            margin-left: 40px;
            width: 95.093%;
            height: 440px;
            position: relative;
            border-top: 1px solid transparent;
            box-sizing: border-box;

            .content-box-bottom-bg {
                width: 100%;
                height: 440px;
                position: absolute;
                top: 0;
                left: 0;
            }

            .content-box-bottom-badge {
                width: 470px;
                height: 423px;
                position: absolute;
                top: -60px;
                right: 97px;
            }

            .content-box-mainbox {
                margin-top: 93px;
                margin-left: 49px;
            }

            .content-box-main {
                margin-right: 20px;
                width: 274px;
                height: 207px;
                border-radius: 20px;
                opacity: 1;

                /* 纯白 */
                background: #FFFFFF;

                box-shadow: 0px 0px 10px 0px rgba(140, 199, 162, 0.2);
                border-radius: 20px;
                opacity: 1;

                /* 纯白 */
                background: #FFFFFF;

                box-shadow: 0px 0px 10px 0px rgba(140, 199, 162, 0.2);
                position: relative;
                z-index: 30;

                img {
                    width: 100px;
                    height: 100px;
                    margin-left: 14px;
                    margin-right: 14px;
                }

                .content-box-main-info {
                    div {
                        &:first-child {

                            font-family: Source Han Sans CN;
                            font-size: 24px;
                            font-weight: bold;
                            line-height: normal;
                            letter-spacing: 0em;

                            font-feature-settings: "kern" on;
                            /* 333333 */
                            color: #333333;
                        }

                        &:last-child {
                            margin-top: 12px;

                            font-family: Oswald;
                            font-size: 24px;
                            font-weight: normal;
                            line-height: normal;
                            letter-spacing: 0em;

                            font-feature-settings: "kern" on;
                            /* 灰 */
                            color: #ACBEB0;
                        }

                    }
                }



            }

            .content-box-btnsbox {
                margin-top: 30px;
                margin-left: 49px;
                position: relative;
                z-index: 20;

                div {
                    &:first-child {
                        text-align: center;
                        margin-right: 22px;
                        width: 134px;
                        height: 46px;
                        border-radius: 100px;

                        /* 绿 */
                        background: #0AA26B;

                        font-family: Source Han Sans CN;
                        font-size: 18px;
                        font-weight: bold;
                        line-height: 46px;
                        letter-spacing: 0em;

                        font-feature-settings: "kern" on;
                        /* 纯白 */
                        color: #FFFFFF;
                    }

                    &:last-child {
                        text-align: center;
                        width: 261px;
                        height: 46px;
                        border-radius: 100px;

                        box-sizing: border-box;
                        /* 绿 */
                        border: 2px solid #0AA26B;

                        font-family: Source Han Sans CN;
                        font-size: 18px;
                        font-weight: normal;
                        line-height: 46px;
                        letter-spacing: 0em;

                        font-feature-settings: "kern" on;
                        /* 绿 */
                        color: #0AA26B;
                    }

                }
            }

        }

    }

    .appraise-popup-title {
        width: 100%;
        height: 86px;
        border-radius: 20px 20px 0 0;
        background: #0AA26B;
        box-sizing: border-box;
        padding: 0 35px;

        .appraise-popup-title-name {
            font-family: 思源黑体;
            font-size: 26px;
            font-weight: bold;
            line-height: normal;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 纯白 */
            color: #FFFFFF;
        }

        img {
            width: 56px;
            height: 56px;
        }
    }

    .start-popup-content {
        background: #fff;
        border-radius: 0 0 20px 20px;
        box-sizing: border-box;
        padding: 0 52px;

        .start-popup-content-text1 {
            margin-left: 173.5px;
            margin-top: 89px;
            font-family: 思源黑体;
            font-size: 22px;
            font-weight: normal;
            line-height: 40px;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 333333 */
            color: #333333;
        }

        .start-popup-content-timebox {
            margin-top: 30px;
            margin-left: 173.5px;

            span {
                margin-right: 30px;
                font-family: 思源黑体;
                font-size: 22px;
                font-weight: normal;
                line-height: 30px;
                letter-spacing: 0em;

                font-feature-settings: "kern" on;
                /* 333333 */
                color: #333333;
            }

            div {
                width: 195px;
                height: 64px;
                border-radius: 100px;
                opacity: 1;

                background: #E5F7F1;

                box-sizing: border-box;
                border: 1px solid rgba(10, 162, 107, 0.2);
            }

        }

        .start-popup-content-tipsbox {
            margin-top: 89px;
            margin-bottom: 75px;
            font-family: 思源黑体;
            font-size: 22px;
            font-weight: normal;
            line-height: 40px;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 确认开始学员 */
            color: #333333
        }

        .start-popup-content-line {
            margin-top: 30px;
            width: 100%;
            height: 0px;
            opacity: 1;

            border: 1px solid rgba(10, 162, 107, 0.2);
        }

        .start-popup-content-btnsbox {
            margin-top: 31px;
            margin-bottom: 30px;

            div {
                &:first-child {
                    margin-right: 20px;
                    width: 230px;
                    height: 64px;
                    border-radius: 100px;
                    /* 灰 */
                    background: #ACBEB0;
                    font-family: 思源黑体;
                    font-size: 28px;
                    font-weight: bold;
                    line-height: 64px;
                    text-align: center;
                    letter-spacing: 0em;

                    font-feature-settings: "kern" on;
                    /* 纯白 */
                    color: #FFFFFF;
                }

                &:last-child {

                    width: 230px;
                    height: 64px;
                    border-radius: 100px;
                    /* 绿 */
                    background: #0AA26B;

                    font-family: 思源黑体;
                    font-size: 28px;
                    font-weight: bold;
                    line-height: 64px;
                    text-align: center;
                    letter-spacing: 0em;

                    font-feature-settings: "kern" on;
                    /* 纯白 */
                    color: #FFFFFF;
                }
            }
        }

    }

}



/deep/ .el-dialog__header {
    border-radius: 20px 20px 0 0;
    padding: 0;

}

/deep/ .el-dialog__body {
    border-radius: 20px;
    padding: 0;
}

/deep/ .el-dialog {
    background: transparent;
    border-radius: 20px;
    box-shadow: 0 0px 0px #ccc;

    @media screen and (min-width: 992px) {
        width: 44.114%;
    }

    @media screen and (max-width: 991px) and (min-width: 768px) {
        width: 82.395%;
    }

    @media screen and (max-width: 767px) {
        width: 100%;
    }




}
</style>